module.exports = __webpack_public_path__ + "static/media/bursting_ball_1.56c9e697.mp3";